<template>
  <modal v-if="modalError" @close="closeModalError">
    <template slot="header">
      <md-button class="md-simple md-just-icon md-round modal-default-button" @click="closeModalError">
        <md-icon>clear</md-icon>
      </md-button>
    </template>

    <template slot="body">
      <span class="md-headline md-error">
        {{dataModalError != '' ? $t(`notifications.errorAction.${dataModalError}`) : $t(`notifications.error`)}}
      </span>
    </template>
    <template slot="footer">
      <md-button class="md-danger" @click="closeModalError">OK</md-button>
    </template>
  </modal>
</template>
<script>
import { Modal } from '@/components'
import { mapState } from 'vuex'

export default {
  components: {
    Modal
  },
  computed: {
    ...mapState({
      modalError: state => state.ModalModule.modalError,
      dataModalError: state => state.ModalModule.dataModalError
    })
  },
  methods: {
    closeModalError() {
      this.$store.dispatch("closeModalError")
    }
  }
}
</script>
<style>
  .modal-footer {
    display: flex;
    justify-content: center;
    margin-top: 12px;
  }
</style>